import React from 'react';
import { DrawerV2, PopoverV2 } from '@withjoy/joykit';

type GuideWrapperProps = Readonly<{
  children: React.ReactNode;
  trigger: React.ReactElement;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}>;

export const MobileWrapper = ({ children, trigger, isOpen, onOpen, onClose }: GuideWrapperProps) => {
  const handleTrigger = () => {
    onOpen();
  };
  const triggerClone = React.cloneElement(trigger, {
    onClick: handleTrigger,
  });
  return (
    <>
      <DrawerV2
        onClose={onClose}
        size="auto"
        isOpen={isOpen}
        anchor="bottom"
        useBackdrop
        overrides={{
          Content: {
            props: {
              height: 'unset',
              borderRadius: '0.5rem 0.5rem 0 0',
              width: '100vw',
              padding: '0',
              maxHeight: '100%',
              overflow: 'auto',
            },
          },
        }}
      >
        <DrawerV2.Body padding={0}>{children}</DrawerV2.Body>
      </DrawerV2>
      {triggerClone}
    </>
  );
};

export const DesktopWrapper = ({ children, trigger, isOpen, onOpen, onClose }: GuideWrapperProps) => {
  return (
    <PopoverV2
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      popperOptions={{
        offset: {
          offset: ({ reference }) => {
            return [-16, reference.height * -1 - 8];
          },
        },
      }}
    >
      <PopoverV2.Trigger>{trigger}</PopoverV2.Trigger>
      <PopoverV2.Content
        borderRadius={3}
        overflow={'hidden'}
      >
        {children}
      </PopoverV2.Content>
    </PopoverV2>
  );
};
